import { styled } from '@mui/material/styles';
import MuiButton from '@mui/material/Button';

export const ShareButton = styled(MuiButton)(({ theme, variant }) => ({
  fontSize: '1rem',
  fontStyle: 'normal',
  fontFamily: 'Proxima Nova SemiBold',
  textTransform: 'none',
  borderRadius: variant === 'contained' || variant === 'outlined' ? '50px' : '0px',
  width: '112px',
  filter:
    variant === 'contained'
      ? 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.50))'
      : 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.08))',
  border:
    variant === 'contained'
      ? `1px solid ${theme.palette.primary.main}`
      : variant === 'outlined'
      ? `1px solid ${theme.palette.neutral4.main}`
      : 'none',
  background:
    variant === 'contained'
      ? theme.palette.primary.main
      : variant === 'outlined'
      ? theme.palette.secondary.main
      : 'none',
  '&:hover': {
    background:
      variant === 'contained'
        ? theme.palette.primary.dark
        : variant === 'outlined'
        ? theme.palette.secondary.dark
        : 'none',
    borderBottom:
      variant === 'contained' || variant === 'outlined'
        ? `1px solid ${theme.palette.primary.main}`
        : '1px dashed',
    color: variant === 'contained' ? theme.palette.white.main : theme.palette.primary.main,
  },
}));
